import { createReducer, on } from '@ngrx/store';
import { findLast, get, isEmpty, take } from 'lodash';

import { IConfigurableSite, IConfigurableSitesState } from '@shared/types/site';

import {
    update_site_selection,
    update_site_selection_failure,
    update_site_selection_success,
} from '../actions/configurable-sites.action';
import { set_iframe_mode } from '../actions/session.action';
import { add_sites_success, configurable_site_selection_from_portal } from '../actions/sites.action';

export const defaultSiteState: IConfigurableSite = {
    selectedSites: [],
    enablePicker: false,
};

/**
 * key: site select key,
 * value site select data
 */
const initialState: IConfigurableSitesState = {
    sites: [],
    enablePicker: false,
};

const _configurableSitesReducer = createReducer(
    initialState,
    on(configurable_site_selection_from_portal, (state, { payload }): IConfigurableSitesState => {
        const compKey = get(payload, 'compKey');

        if (isEmpty(compKey)) {
            /**
             * not configured any key, just return
             */
            return;
        }

        const sites = payload.payload.items.map((item) =>
            findLast(state.sites, (allSitesItem) => allSitesItem.id === item.id),
        );

        const isMultiple = payload.isMultiple;

        const curModuleState = {
            ...get(state, ['componentSites', compKey], defaultSiteState),
            selectedSites: isMultiple ? sites : take(sites),
        };

        return {
            ...state,
            componentSites: {
                ...get(state, 'componentSites', {}),
                [compKey]: curModuleState,
            },
        };
    }),
    on(set_iframe_mode, (state, { isIframeMode }): IConfigurableSitesState => {
        return { ...state, enablePicker: isIframeMode };
    }),

    on(add_sites_success, (state, data): IConfigurableSitesState => {
        const { sites } = data;

        return {
            ...state,
            sites,
        };
    }),

    on(update_site_selection, (state, payload): IConfigurableSitesState => {
        return { ...state, ...payload };
    }),

    on(update_site_selection_success, (state, { compKey, value }): IConfigurableSitesState => {
        const { isMultiple, sites } = value;

        return {
            ...state,
            componentSites: {
                ...get(state, ['componentSites'], {}),
                [compKey]: {
                    ...get(state, compKey, defaultSiteState),
                    selectedSites: isMultiple ? sites : take(sites),
                },
            },
        };
    }),

    on(update_site_selection_failure, (state): IConfigurableSitesState => state),
);

export function configurableSitesReducer(state, action) {
    return _configurableSitesReducer(state, action);
}
